import { render, staticRenderFns } from "./QuestionbankTypePopu.vue?vue&type=template&id=711ce82c&"
import script from "./QuestionbankTypePopu.vue?vue&type=script&lang=js&"
export * from "./QuestionbankTypePopu.vue?vue&type=script&lang=js&"
import style0 from "./QuestionbankTypePopu.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports